import React from "react";
import TextField from "../../UI/Inputs/TextField.js";
import DropDown from "../../UI/Inputs/DropDown.js";
import IconSelector from "../../UI/Inputs/IconSelector.js";

const BasicQuestions = ({ data, setter, questionTypes }) => {
  const { question, type, remarks, icon, required } = data;

  
  return (
    <div className="border-gray-300 border-2 p-4 rounded-md">
      <p className="text-lg">General properties</p>
      <div className="">
        <TextField
          label="Question"
          placeholder={"Add Question"}
          name={"question"}
          value={question}
          type={"text-area"}
          onValueChange={(_, value) => setter({ ...data, question: value })}
        />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
          <DropDown
            label="Response Type"
            placeholder={"Select Response Type"}
            name={"type"}
            value={type}
            options={[
              ...questionTypes,
            ]}
            onValueChange={(value) => {
              if (value) {
                setter({ ...data, type: value });
              }
            }}
            style={{ padding: "8px" }}
          />
          <IconSelector
            onSelect={(icon) => setter({ ...data, icon: icon })}
            initialIcon={icon}
          />
          <DropDown
            label="Required"
            placeholder={"Select Yes if Required "}
            name={"required"}
            value={required}
            options={[
              { name: "Yes", value: "yes" },
              { name: "No", value: "no" },
            ]}
            onValueChange={(value) => {
              if (value ) {
                setter({ ...data, required: value });
              }
            }}
            style={{ padding: "8px" }}
          />
        </div>
        <TextField
          label="Remarks"
          placeholder={"Add Remarks"}
          name={"remarks"}
          value={remarks}
          onValueChange={(_, value) => setter({ ...data, remarks: value })}
          type={"text-area"}
        />
      </div>
    </div>
  );
};

export default BasicQuestions;
